<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <CCard>
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Pengajuan Rekomendasi
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)"
        >Kembali</Button>
      </div>
      <!-- Data dokumen -->
      <CCardBody>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable 
              style="widht:100% !important" 
              :items="items" 
              :fields="fields"
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data .." }'
              :items-per-page="10"              
              :items-per-page-select='{ label : "Data Per Halaman"}'  
              hover 
              sorter
              :pagination='{ class: "float-right" }'
            >
              <template #no="{index}">
                <td class="py-2">{{ index+1 }}</td>
              </template>
              <template #nama_dokumen="{item}">
                <td class="py-2 text-left">{{item.nama_dokumen ? item.nama_dokumen : "-"}}</td>
              </template>
              <template #created_at="{item}">
                <td class="py-2 text-left">{{item.created_at ? item.created_at : "-"}}</td>
              </template>
              <template #status_wajib="{item}">
                <td 
                  class="font-weight-bold text-left"
                  :class="{
                    'text-success': item.status_wajib == '1',
                    'text-danger': item.status_wajib == '0',
                  }"
                >
                  {{ item.status_wajib == '1' ? 'Wajib' : 'Tidak Wajib' }}
                </td>                   
              </template>  
              <template #status_upload="{item}">
                <td
                  class="font-weight-bold text-secondary"
                  v-if="item.status_upload == '0'"
                >Belum Upload</td>
                <td
                  class="font-weight-bold text-success"
                  v-if="item.status_upload == '1'"
                >Terverifikasi</td>
                <td
                  class="font-weight-bold text-primary"
                  v-if="item.status_upload == '2'"
                >Sudah Upload</td>
                <td
                  class="font-weight-bold text-info"
                  v-if="item.status_upload == '3'"
                >File Tidak Terbaca</td>
                <td
                  class="font-weight-bold text-danger"
                  v-if="item.status_upload == '4'"
                >File Tidak Sesuai</td>
              </template>
              <template #aksi="{item, index}">
                <td class="py-2 text-center">
                <CButton
                    color="warning"
                    class="btn-sm text-white mr-2"
                    square
                    v-c-tooltip="'Lihat File'"
                    @click="lihatFile(item)">
                    <small><i class="fa fa-eye"></i></small>
                  </CButton>
                  <CButton
                    color="info"
                    class="btn-sm text-white"
                    square
                    v-c-tooltip="'Verifikasi'"
                    @click="verifikasiDokumen(item, index)"
                  ><small><i class="fa fa-check"  ></i></small></CButton>
                </td>
              </template>
            </CDataTable>
           
          </CCol>
        </CRow>
        <!-- Modal Verifikasi -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <CCol sm="12">
              <label for class="font-weight-bold">Diverifikasi Pada</label>
              <br />
              <CInput class="font-weight-bold" type="date" v-model="formData.verifikasiPada" />
            </CCol>
              <CCol sm="12 mb-2">
                <label for class="font-weight-bold">Status</label>
                <select name="id_outlet" v-model="formData.statusUpload" class="form-control mb-2">
                  <option value="1" :selected="formData.statusUpload == '1'">Terverifikasi</option>
                  <option value="3" :selected="formData.statusUpload == '3'">File Tidak Terbaca</option>
                  <option value="4" :selected="formData.statusUpload == '4'">File Tidak Sesuai</option>
                </select>
              </CCol>
              <CCol v-if="formData.statusUpload != '1'">
                 <label for class="font-weight-bold">Alasan <span>(Opsional)</span></label>
                <textarea 
                  class="form-control" 
                  name="" 
                  id="" 
                  cols="30" 
                  rows="4" 
                  v-model="formData.alasan" 
                  placeholder="Masukkan alasan">
                </textarea>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h5 font-weight-bold">Verifikasi Data Dokumen
              
            </h6>
          </template>
          <template #footer>
            <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" @click="verif" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data Dokumen -->
    </CCard>
  </div>
</template>
<script>
import RekomendasiService from "@/services/keanggotaan/rekomendasi.service";
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import Utils from "@/services/utils.service";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama_dokumen",
    label: "Nama Dokumen",
    sorter: true,
    filter: false
  },
   {
    key: "status_wajib",
    label: "Status Dokumen",
    sorter: true,
    filter: false,    
  },
  {
    key: "status_upload",
    label: "Status Dokumen",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width:11%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  data() {
    return {
      modalVerif: false,
      actionPost: "",
      items: [],
      formData: {
        idDokumenPendukungPeserta: "",
        statusVerifikasi: "",
        tanggalVerifikasi: "",
        statusUpload: "",
        alasan: "",
        verifikasiPada: new Date().toISOString().slice(0, 10)
      },
      currentPage: 3,
      details: [],
      no: 1,
      fields,
      status: false,
      modalVerif: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  mounted() {
    this.getDokumenRekomendasi();

    $(function() {
      $('input[name="daterange"]').daterangepicker(
        {
          opens: "auto",
          autoApply: true,
          singleDatePicker: true
        },
        function(start, end, label) {
          // comment console console.log(
            
        }
      );
    });
  },
  methods: {
    lihatFile(item) {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item.file+"/lokasi/data_dokumen_pendukung/bearer/" + token,
        item.file,
        params
      );
    },

    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    alertVerif() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Ubah"
      });
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    verifikasiDokumen(item, index) {      
      this.modalVerif = true;
      this.formData = {
        idDokumenPendukungPeserta: item.id_dokumen_pendukung_peserta,
        statusUpload: item.status_upload,
        alasan: item.alasan,
        verifikasiPada: new Date().toISOString().slice(0, 10)
      }      
      this.index = index;
    },

    getDokumenRekomendasi() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      RekomendasiService.getDokumenRekomendasi(
        this.$route.params.id_rekomendasi_peserta
      )
        .then(response => {
          loader.hide();          
          this.items = response.data.data;          
          var rekomendasi = response.data.data.id_dokumen_pendukung_peserta;
          this.formData.id_dokumen_pendukung_peserta = rekomendasi;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },

    verif() {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      this.formData = {
        idDokumenPendukungPeserta: vm.formData.idDokumenPendukungPeserta,
        statusUpload: vm.formData.statusUpload,
        alasan: vm.formData.alasan,
        verifikasiPada: vm.formData.verifikasiPada
      }
      // comment console console.log(this.formData)
      DataKeanggotaanService.verifikasiDataDokumen(this.formData)
        .then(response => {
          // comment console console.log(response);
          this.modalVerif = false;
          this.alertVerif();
          vm.getDokumenRekomendasi();
          loader.hide();
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide();
        });
    }
  }
};
</script>